module.exports = __webpack_public_path__ + "static/img/6672276.2a14d13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6672276.jpg
// module id = 1071
// module chunks = 6 23